const apimBaseByEnv: Record<string, string> = {
  development: "https://crdev-apim.azure-api.net",
  staging: "https://crstage-apim.azure-api.net",
  production: "https://api.clubready.com",
};

// Two distinct prod subscription keys existed in source (one for the
// /security/v1/token call, one for the general "new" API calls) even though
// both target api.clubready.com — different APIM products. Preserve that
// split per env rather than collapsing them.
//
// Dev/stage values below are empirically confirmed against crdev-apim /
// crstage-apim. Dev key matches Scheduling.StaticWebHost's .env.dev; stage key
// matches Qa.Integration's ClubInvoicesDstHandlingTests. Note crdev-apim.azure-api.net
// and api.clubreadydev.com are two names for the same dev gateway.
//
// Every dev/stage APIM product DOES enforce the subscription key — including
// clubs/v1, users/v1 and sales/v1. An invalid key is rejected by APIM before it
// reaches the backend, with a JSON body "Access denied due to invalid
// subscription key"; a valid key is forwarded and the backend answers on its own
// (e.g. an empty-bodied 401 for a missing bearer). Both keys below were probed
// that way against clubs/v1 and security/v1/token and are valid across products.
export const tokenApimSubscriptionKeyByEnv: Record<string, string> = {
  development: "5c26b591fb5849b7b2088a34d903aadf",
  staging: "031d4f5f4f824287a932a162fd69533a",
  production: "063964d934ae48ac8b1eddbdd028d8db",
};

export const apimSubscriptionKeyByEnv: Record<string, string> = {
  development: "5c26b591fb5849b7b2088a34d903aadf",
  staging: "031d4f5f4f824287a932a162fd69533a",
  production: "78fcd93ec3314036bea9a98c1a4d13af",
};

// Same REACT_APP_ENV the pipeline sets per stage (see validateParentDomain.ts);
// unset/unknown falls back to prod, matching behavior before per-env bases existed.
const resolvedEnv = process.env.REACT_APP_ENV as string;

export const new_api_url: string =
  apimBaseByEnv[resolvedEnv] ?? apimBaseByEnv.production;

export const apim_subscription_key: string =
  apimSubscriptionKeyByEnv[resolvedEnv] ?? apimSubscriptionKeyByEnv.production;

export const token_apim_subscription_key: string =
  tokenApimSubscriptionKeyByEnv[resolvedEnv] ??
  tokenApimSubscriptionKeyByEnv.production;

export const get_tokens_url: string = `${new_api_url}/security/v1/token`;
export const get_auth_token_url: string =
  "https://piq-api.myperformanceiq.com/el/gt";
export const send_cr_request_url: string =
  "https://piq-api.myperformanceiq.com/el/send-cr-request";
export const piq_widget: string = "https://piq-api.myperformanceiq.com/widgets";
export const piq_api_url = "https://piq-api.myperformanceiq.com/piq-api/Test";

export const apis: any = {
  get_user_by_id: {
    type: "new",
    url: `${new_api_url}/users/v1/users/{UserId}`,
  },
  get_user_agreements: {
    type: "new",
    url: `${new_api_url}/sales/v1/users/agreements?StoreId={StoreId}&UserId={UserId}&PageSize=1000`,
  },
  get_package: {
    type: "new",
    url: `${new_api_url}/sales/v1/clubs/{ClubId}/packages/{PackageId}`,
  },
  cancel_agreement_on_future_date: {
    type: "new",
    url: `${new_api_url}/sales/v1/agreements/{AgreementId}/cancel/{CancellationDate}?CancelledById={CancelledById}&CancelNote={CancelNote}&CancellationReason=131`,
  },
  cancel_agreement: {
    type: "new",
    url: `${new_api_url}/sales/v1/agreements/{AgreementId}/cancel?CancelledById={CancelledById}&CancelNote={CancelNote}&CancellationReason=131`,
  },
  click_to_cancel_login: {
    type: "new",
    url: `${new_api_url}/security/v1/clubs/{clubId}/users/click-to-cancel/login`,
  },
  get_club: {
    type: "new",
    url: `${new_api_url}/clubs/v1/clubs/{clubId}`,
  },
};
